# frozen_string_literal: true

require_relative 'take_loan'

module Engine
  module Action
    class PayoffLoan < TakeLoan
    end
  end
end
